import * as actions from "@/store/action-types";
import * as mutations from "@/store/mutation-types";
import store from "@/store";

export default {
  [actions.LOGIN]({ commit }, payload) {
    sessionStorage.setItem("radius-user-state", JSON.stringify(store.state));

    commit(mutations.SET_USER, {
      user: payload.user,
      auth_token: payload.auth_token
    });

    commit(mutations.SET_ORGANISATION, {
      summary: payload.organisation,
      features: payload.features,
      permissions: payload.permissions,
      is_owner:
        payload.organisation_account_user &&
        payload.organisation_account_user.is_owner === 1
    });

    commit(mutations.SET_SWITCH_KEY, new Date().getTime())
  },

  [actions.USER]({ commit }, payload) {
    commit(mutations.SET_USER, payload);
  },

  [actions.ORGANISATION]({ commit }, payload) {
    commit(mutations.SET_ORGANISATION, payload);
  },

  [actions.ORGANISATIONS]({ commit }, payload) {
    commit(mutations.SET_ORGANISATIONS, payload);
  },

  [actions.WALLET]({ commit }, payload) {
    commit(mutations.SET_WALLET, payload);
  },

  [actions.SWITCH_KEY]({ commit }, payload) {
    commit(mutations.SET_SWITCH_KEY, payload);
  },

  [actions.LOGOUT]({ commit }) {
    return new Promise(resolve => {
      const defaultState = JSON.parse(
        sessionStorage.getItem("radius-user-state")
      );
      commit(mutations.LOGOUT, defaultState);
      sessionStorage.clear();

      resolve(true);
    });
  }
};
